export const INSTAGRAM_MAX_DESCRIPTION_CHARS = 2200;
export const INSTAGRAM_MAX_STORY_DURATION_SEC = 60;
